import React from "react"

const GoogleMap = () => (
  <div
    style={{
      height: 430,
      width: "100%",
      border: "1px solid #7a7a7a",
      boxSizing: "content-box",
    }}
  >
    <div className="mapouter">
      <div className="gmap_canvas">
        <iframe
          title="Posizione Materia3 nella mappa"
          width="100%"
          height="430"
          id="gmap_canvas"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2881.4358826271646!2d11.165068615501344!3d43.76380997911767!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xc38cb72c9d24d1ee!2sMateria3!5e0!3m2!1sit!2sit!4v1601483999859!5m2!1sit!2sit"
          frameBorder="0"
          scrolling="no"
          marginHeight="0"
          marginWidth="0"
        />
      </div>
    </div>
  </div>
)

export default GoogleMap
